var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{style:({ 'background-color': this.background_color }),attrs:{"id":"daily-tip-container"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.banner_content)}}),_c('div',{attrs:{"id":"dismiss"},on:{"click":function($event){return _vm.close()}}},[_vm._m(0)])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"fas fa-times-circle"})])
}]

export { render, staticRenderFns }